/* jshint node:true */
'use strict';

var React = require('react');

var Penalties = React.createClass({

    displayName: 'Penalties',

    render: function () {

        return (

            <article className="sub-module penalty-shootout">



                <header>
                    <h1>Penalty Shootouts</h1>
                </header>

                <div className="competitors">

                    <div className="team away">
                        <div className="logo">
                            <img src="http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/360.png?w=100&amp;h=100&amp;transparent=true" />
                        </div>
                        <div className="team-name"><span>Manchester United</span><abbr>MUN</abbr></div>
                    </div>

                    <div className="team home">
                        <div className="team-name"><span>Manchester City</span><abbr>MCY</abbr></div>
                        <div className="logo">
                            <img src="http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/382.png?w=100&amp;h=100&amp;transparent=true" />
                        </div>
                    </div>

                </div>

                <table>
                    <tbody><tr>
                        <td className="team-away shot-made">
                            <a className="game-icon icon-font-before icon-play-solid-before"></a>
                            <div className="player-name">Lorem Ipsumipsum</div>
                            <div className="game-icon icon-font-before icon-soccer-ball-before icon-soccerball"></div>
                        </td>

                        <td className="penalty"><span>Pen</span> 1</td>

                        <td className="team-home shot-made">
                            <div className="game-icon icon-font-before icon-soccer-ball-before icon-soccerball"></div>
                            <div className="player-name">Lorem Ipsum</div>
                            <a className="game-icon icon-font-before icon-play-solid-before"></a>
                        </td>
                    </tr>

                    <tr>
                        <td className="team-away shot-missed">
                            <a className="game-icon icon-font-before icon-play-solid-before"></a>
                            <div className="player-name">Lorem Ipsum</div>
                            <div className="game-icon icon-font-before icon-soccer-ball-before icon-soccerball"></div>
                        </td>

                        <td className="penalty"><span>Pen</span> 2</td>

                        <td className="team-home shot-made">
                            <div className="game-icon icon-font-before icon-soccer-ball-before icon-soccerball"></div>
                            <div className="player-name">Lorem Ipsumipsum</div>
                            <a className="game-icon icon-font-before icon-play-solid-before"></a>
                        </td>
                    </tr>

                    <tr>
                        <td className="team-away shot-made">
                            <a className="game-icon icon-font-before icon-play-solid-before"></a>
                            <div className="player-name">Lorem Ipsumipsumipsum</div>
                            <div className="game-icon icon-font-before icon-soccer-ball-before icon-soccerball"></div>
                        </td>

                        <td className="penalty"><span>Pen</span> 3</td>

                        <td className="team-home shot-missed">
                            <div className="game-icon icon-font-before icon-soccer-ball-before icon-soccerball"></div>
                            <div className="player-name">Lorem Ipsumipsum</div>
                            <a className="game-icon icon-font-before icon-play-solid-before"></a>
                        </td>
                    </tr>

                    <tr className="inactive">
                        <td className="team-away">
                            <div className="game-icon icon-font-before icon-soccer-ball-before icon-soccerball"></div>
                        </td>

                        <td className="penalty"><span>Pen</span> 4</td>

                        <td className="team-home">
                            <div className="game-icon icon-font-before icon-soccer-ball-before icon-soccerball"></div>
                        </td>
                    </tr>

                    <tr className="inactive">
                        <td className="team-away">
                            <div className="game-icon icon-font-before icon-soccer-ball-before icon-soccerball"></div>
                        </td>

                        <td className="penalty"><span>Pen</span> 5</td>

                        <td className="team-home">
                            <div className="game-icon icon-font-before icon-soccer-ball-before icon-soccerball"></div>
                        </td>
                    </tr>
                </tbody>
                </table>

            </article>

        );
    }
});

module.exports = Penalties;






/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/Penalties.jsx
 **/